<script lang="ts">
	import { page } from '$app/state';
	import { Markdown } from '$global/components/Markdown';
	import type { GlobalHomePageData } from '$routes/types';

	const dataCy = 'home-about-intro';

	let data = $derived(page.data as GlobalHomePageData);
	let aboutIntro = $derived(data.aboutIntro);
</script>

{#if aboutIntro}
	<section data-cy={dataCy} class="max-w-4xl">
		<div>
			<Markdown
				dataCy={`${dataCy}-text`}
				source={aboutIntro}
				color="black"
				size="large"
				class="font-[600] [&>p]:mb-0 [&>p]:text-gray-900 sm:[&>p]:text-[1.25rem] sm:[&>p]:leading-[1.5]"
			/>
		</div>
	</section>
{/if}
